import { BottomNavigation } from "@/components/BottomNavigation";
import { PendingInvitationBanner } from "@/components/PendingInvitationBanner";
import { ReactNode } from "react";

interface AppLayoutProps {
  children: ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  return (
    <div className="min-h-screen bg-gradient-soft pb-20 overflow-x-hidden w-full max-w-full">
      <PendingInvitationBanner />
      {children}
      <BottomNavigation />
    </div>
  );
}